export function isRowSelectedInSelectionModel(selectionModel, rowId) {
  if (!Array.isArray(selectionModel) || rowId == null) return false;
  const normalizedRowId = String(rowId);
  return selectionModel.some((selectedId) => String(selectedId) === normalizedRowId);
}

export function getShipmentInvoiceId(shipment) {
  if (!shipment) return null;

  if (shipment.invoice_number != null) return shipment.invoice_number;
  if (shipment.invoice_id != null) return shipment.invoice_id;
  if (shipment.current_invoice_id != null) return shipment.current_invoice_id;

  if (shipment.invoice != null) {
    if (typeof shipment.invoice === 'object') return shipment.invoice.id ?? null;
    return shipment.invoice;
  }

  if (Array.isArray(shipment.invoices) && shipment.invoices.length > 0) {
    const first = shipment.invoices[0];
    return typeof first === 'object' ? first.id : first;
  }

  return null;
}

export function selectedShipmentsHaveDifferentInvoices(selectedShipments) {
  const invoiceIds = selectedShipments
    .filter((row) => row.invoiced)
    .map((row) => getShipmentInvoiceId(row))
    .filter((id) => id != null);

  return new Set(invoiceIds.map(String)).size > 1;
}
